/* eslint one-var: [0]*/
/* eslint max-len: [0]*/
/* eslint max-lines: [0]*/
/* eslint max-params: [0]*/
/* eslint complexity: [0]*/
/* eslint no-multi-assign: [0]*/
/* eslint prefer-const: [0]*/
/* eslint consistent-return: [0] */

import Modernizr from 'modernizr';
import Barba from 'barba.js';
import Utils from '../utils/utils.js';
import Api from '../utils/api.js';
import DayHighlightChooser from '../components/dayHighlightChooser.js';
import DayEventsList from '../components/dayEventsList.js';

const api = new Api();
const dayHighlightChooser = new DayHighlightChooser();
const dayEventsList = new DayEventsList();

const onResizeGroupEventHighlights = ( event ) => {
		const $eventHighlightContainer = jQuery( '.c-event-highlights' ),
			eventHighlightScrollContainerClass = 'c-event-highlights__scroll-container';	
		
		if ( Modernizr.mq( '(min-width: 992px)' ) ){
			if ( $eventHighlightContainer.length && $eventHighlightContainer.find( `.${eventHighlightScrollContainerClass}` ).length ){
				const $eventHighlightScrollContainer = $eventHighlightContainer.find( `.${eventHighlightScrollContainerClass}` ),
					$eventHighlightScrollitems = $eventHighlightScrollContainer.find( '.c-event-highlights__item:not(.c-event-highlights__item:nth-child(1))' );
				$eventHighlightScrollitems.unwrap().unwrap();
			}
		} else if ( ! $eventHighlightContainer.find( `.${eventHighlightScrollContainerClass}` ).length ) {
			const $eventHighlightScrollitems = $eventHighlightContainer.find( '.c-event-highlights__item:not(.c-event-highlights__item:nth-child(1))' );
			$eventHighlightScrollitems.wrapAll( `<div class="${eventHighlightScrollContainerClass} float-left w-full mt-05"><div class="${eventHighlightScrollContainerClass}-inner clearfix"></div></div>` );
		}
	}, 
	lazyOnResizeGroupEventHighlights = Utils.debounce( onResizeGroupEventHighlights, 250 );

export default Barba.BaseView.extend( {
	namespace: 'template-home',
	onEnter() {
		// The new Container is ready and attached to the DOM.
		jQuery( window ).on( 'resize.oax::group-event-highlights', lazyOnResizeGroupEventHighlights );
		onResizeGroupEventHighlights();

		jQuery( '.c-btn-select-toggle' ).addClass( 'opacity-0' );

		api.getAllDays().then( ( result ) => {
			dayHighlightChooser.init( result );
			dayEventsList.init( result );
		} );
	},

	onEnterCompleted() {
		// The Transition has just finished.
	},

	onLeave() {
		// A new Transition toward a new page has just started.
		jQuery( window ).off( 'resize.oax::group-event-highlights', lazyOnResizeGroupEventHighlights );
	},

	onLeaveCompleted() {
		// The Container has just been removed from the DOM.
	},
} );
